module.exports = __webpack_public_path__ + "img/zd-new-5.f01346c2.svg";